import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import "./PopUp.css";
import PopUpImage from "./content//main/MerseySidePort.png";

const modalStyle = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    textAlign: "center",
  },
  content: {
    position: "absolute",
    top: "50px",
    left: "50px",
    right: "50px",
    bottom: "50px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "5px",
    outline: "none",
    padding: "20px",
  },
};

const PopUp = ({ buttonName, className, withImage, iconName, iconSize, fixedButton, navigateCallback }) => {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [showOverview, setShowOverview] = React.useState(true);
  const [showFutureConsiderations, setShowFutureConsiderations] = React.useState(false);
  const [showUseCases, setShowUseCases] = React.useState(false);
  const [canClick, setCanClick] = useState(false);

  const onClickOverview = () => {
    setShowOverview(true);
    setShowFutureConsiderations(false);
    setShowUseCases(false);
  };

  const onClickFutureConsiderations = () => {
    setShowOverview(false);
    setShowFutureConsiderations(true);
    setShowUseCases(false);
  };

  const onClickUseCases = () => {
    setShowOverview(false);
    setShowFutureConsiderations(false);
    setShowUseCases(true);
  };

  let buttonStyleArray = className.split(" ");
  let pointerStyle = buttonStyleArray[0];
  let connectorStyle = buttonStyleArray[1];
  let buttonStyle = buttonStyleArray[2];

  var canvas = document.createElement("canvas");
  var mapCanvas = document.createElement("canvas");

  useEffect(() => {
    let imgRef = document.getElementById("map");
    mapCanvas.width = imgRef.width;
    mapCanvas.height = imgRef.height;
    mapCanvas.getContext("2d").drawImage(imgRef, 0, 0, imgRef.width, imgRef.height);

    if (withImage) {
      let img = document.getElementById("icon" + iconName);
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height);
    }
  });

  var pixelData;

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  function highlightGroup(event) {
    pixelData = canvas.getContext("2d").getImageData(event.nativeEvent.offsetX, event.nativeEvent.offsetY, 1, 1).data;
    for (var i = 0; i < pixelData.length; i++) {
      if (pixelData[i] !== 0) {
        setCanClick(true);
      } else {
        setCanClick(false);
      }
    }
  }

  function highlightIcon() {
    setCanClick(true);
  }

  function unhighlightIcon() {
    setCanClick(false);
  }

  function animateToDescription() {
    navigateCallback();
    setIsOpen(false);
  }

  return (
    <div>
      {withImage ? (
        canClick ? (
          <img
            id={"icon" + iconName}
            alt="Highlighted Map Icon"
            src={require("./content/" + iconName + "-highlighted.png").default}
            className="PopUp-ship-icon"
            style={{ width: iconSize + "vw", cursor: "pointer" }}
            /* style={{ border: '1.5px solid rgb(25, 26, 24)' }} */ onMouseMove={(event) => highlightGroup(event)}
            onMouseLeave={unhighlightIcon}
            onClick={openModal}
          ></img>
        ) : (
          <img
            id={"icon" + iconName}
            alt="Normal Map Icon"
            src={require("./content/" + iconName + "-normal.png").default}
            className="PopUp-ship-icon"
            style={{ width: iconSize + "vw", cursor: "default" }}
            /* style={{ border: '1.5px solid rgb(25, 26, 24)' }} */ onMouseMove={(event) => highlightGroup(event)}
            onMouseLeave={unhighlightIcon}
          ></img>
        )
      ) : null}

      <div className={pointerStyle} onMouseOver={highlightIcon} onMouseLeave={unhighlightIcon} onClick={openModal}>
        <div className={connectorStyle} onMouseOver={highlightIcon} onMouseLeave={unhighlightIcon} onClick={openModal}>
          <button className={buttonStyle} onMouseOver={highlightIcon} onMouseLeave={unhighlightIcon} onClick={openModal}>
            {buttonName}
          </button>
        </div>
      </div>

      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} ariaHideApp={false} style={modalStyle} shouldFocusAfterRender={false}>
        <div className="PopUp-modal-container">
          <button className="PopUp-modal-close" onClick={closeModal}>
            &times;
          </button>
          <div className="PopUp-modal-menu">
            <img src={PopUpImage} alt="Popup Placeholder" className="PopUp-placeholder-image" />
            <button onClick={onClickOverview} className="PopUp-modal-menu-button">
              Overview
            </button>
            <button onClick={onClickFutureConsiderations} className="PopUp-modal-menu-button">
              Future Considerations
            </button>
            <button onClick={onClickUseCases} className="PopUp-modal-menu-button">
              Use Cases
            </button>
          </div>
          {showOverview ? (
            <div id="overview" className="PopUp-modal-content">
              <h2>Remove redundant birth movements within the port</h2>
              <h5>An interesting stat that shows how compelling this challenge might be</h5>
              <h6>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.<br></br>
              </h6>
              <h6>
                Use Cases:
                <br />
                1. Asset sharing between tenants
                <br />
                2. Modular asset delivery systems on the shoreside
                <br />
                3. Forecasting and scheduling of ships to enable fewer movements
              </h6>
            </div>
          ) : null}
          {showFutureConsiderations ? (
            <div id="futureConsiderations" className="PopUp-modal-content">
              <h2>Remove redundant birth movements within the port</h2>
              <h5>An interesting stat that shows how compelling this challenge might be</h5>
              <h6>
                Indicators
                <br />
                <br />
                Insight 1:
                <br />
                <br />
                Interesting fact about something that might affect the future something like all of the corporations will only use ships that don't emit emissions
                <br />
                <br />
                Insight 2:
                <br />
                <br />
                Interesting fact about something that might affect the future something like all of the corporations will only use ships that don't emit emissions
              </h6>
            </div>
          ) : null}
          {showUseCases ? (
            <div id="useCases" className="PopUp-modal-content">
              <h2>Remove redundant birth movements within the port</h2>
              <h6>Click on the use case for more details...</h6>
              {showUseCases ? (
                <div>
                  <button onClick={animateToDescription} className="PopUp-use-case-button" style={{ position: "relative" }}>
                    Asset sharing
                    <br />
                    between tenants
                    <div className="PopUp-arrow-tab-menu">
                      <div className="PopUp-pointer-tab-menu" />
                    </div>
                  </button>
                  <button onClick={animateToDescription} className="PopUp-use-case-button" style={{ position: "relative" }}>
                    Modular asset delivery systems
                    <br />
                    on the shoreside
                    <div className="PopUp-arrow-tab-menu">
                      <div className="PopUp-pointer-tab-menu" />
                    </div>
                  </button>
                  <button onClick={animateToDescription} className="PopUp-use-case-button" style={{ position: "relative" }}>
                    Forecasting and scheduling
                    <br />
                    of ships
                    <div className="PopUp-arrow-tab-menu">
                      <div className="PopUp-pointer-tab-menu" />
                    </div>
                  </button>
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
      </Modal>
    </div>
  );
};

export default PopUp;
